import type { IAnimationConfig, ICardsConfig } from './models';

export const animation: IAnimationConfig = {
    cubicBezier: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
    duration: 1,
};

export const card: ICardsConfig = {
    spacing: 25,
    containerWidth: 1140,
};
